import React from 'react';
import products from '../information/Products';
import ProductCard from '../components/ProductCard';
import '../styles/products.css';

const Products = ({ onNavigate }) => {
  return (
    <div className="products-page">

      <section className="products-hero">
        <p className="products-page-label">NUESTROS PRODUCTOS</p>
        <h1 className="products-hero-heading fredoka-400">
          Apps que simplifican tu día a día.
        </h1>
        <p className="products-hero-sub">
          Soluciones propias diseñadas para pymes, autónomos, particulares y más.
        </p>
      </section>

      <section className="products-grid-section">
        <div className="products-grid">
          {products.products && products.products.map((product) => (
            <ProductCard
              key={product.id}
              id={product.id}
              title={product.title}
              tagline={product.tagline}
              description={product.description}
              list={product.list}
              image={product.image}
              color={product.color}
              platforms={product.platforms}
              status={product.status}
              url={product.url}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      </section>

    </div>
  );
};

export default Products;
